module.exports = __webpack_public_path__ + "img/btn-circle.bf3029a6.svg";